import {pluralize} from "@pg-mono/string-utils";

import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";

export const getPlannerPropertyRoomName = (roomType: IPlannerRoomNames | null): ((n: number) => string) => {
    switch (roomType) {
        case IPlannerRoomNames.Kitchen:
            return pluralize(["kuchnia", "kuchnie", "kuchni"]);
        case IPlannerRoomNames.LivingRoom:
            return pluralize(["salon", "salony", "salonów"]);
        case IPlannerRoomNames.DiningRoom:
            return pluralize(["jadalnia", "jadalnie", "jadalni"]);
        case IPlannerRoomNames.Bedroom:
            return pluralize(["sypialnia", "sypialnie", "sypialni"]);
        case IPlannerRoomNames.Bathroom:
            return pluralize(["łazienka", "łazienki", "łazienek"]);
        default:
            return () => "";
    }
};

export const getPlannerPropertyRoomNameDeclensionWhere = (roomType: IPlannerRoomNames | null): ((n: number) => string) => {
    switch (roomType) {
        case IPlannerRoomNames.Kitchen:
            return pluralize(["kuchni", "kuchni", "kuchni"]);
        case IPlannerRoomNames.LivingRoom:
            return pluralize(["salonu", "salonów", "salonów"]);
        case IPlannerRoomNames.LivingRoomWithKitchenette:
            return pluralize(["pokoju dziennego z aneksem", "pokoi dziennych z aneksem", "pokoi dziennych z aneksem"]);
        case IPlannerRoomNames.DiningRoom:
            return pluralize(["jadalni", "jadalni", "jadalni"]);
        case IPlannerRoomNames.Bedroom:
            return pluralize(["sypialni", "sypialni", "sypialni"]);
        case IPlannerRoomNames.Bathroom:
            return pluralize(["łazienki", "łazienek", "łazienek"]);
        default:
            return () => "";
    }
};
import {pluralize} from "@pg-mono/string-utils";

import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";

export const getPlannerPropertyRoomName = (roomType: IPlannerRoomNames | null): ((n: number) => string) => {
    switch (roomType) {
        case IPlannerRoomNames.Kitchen:
            return pluralize(["kuchnia", "kuchnie", "kuchni"]);
        case IPlannerRoomNames.LivingRoom:
            return pluralize(["salon", "salony", "salonów"]);
        case IPlannerRoomNames.DiningRoom:
            return pluralize(["jadalnia", "jadalnie", "jadalni"]);
        case IPlannerRoomNames.Bedroom:
            return pluralize(["sypialnia", "sypialnie", "sypialni"]);
        case IPlannerRoomNames.Bathroom:
            return pluralize(["łazienka", "łazienki", "łazienek"]);
        default:
            return () => "";
    }
};

export const getPlannerPropertyRoomNameDeclensionWhere = (roomType: IPlannerRoomNames | null): ((n: number) => string) => {
    switch (roomType) {
        case IPlannerRoomNames.Kitchen:
            return pluralize(["kuchni", "kuchni", "kuchni"]);
        case IPlannerRoomNames.LivingRoom:
            return pluralize(["salonu", "salonów", "salonów"]);
        case IPlannerRoomNames.LivingRoomWithKitchenette:
            return pluralize(["pokoju dziennego z aneksem", "pokoi dziennych z aneksem", "pokoi dziennych z aneksem"]);
        case IPlannerRoomNames.DiningRoom:
            return pluralize(["jadalni", "jadalni", "jadalni"]);
        case IPlannerRoomNames.Bedroom:
            return pluralize(["sypialni", "sypialni", "sypialni"]);
        case IPlannerRoomNames.Bathroom:
            return pluralize(["łazienki", "łazienek", "łazienek"]);
        default:
            return () => "";
    }
};
